import { entityForPath, routeForEntity } from './favoriteEntities';

export type FavKind = 'record' | 'route';
export type FavoriteContext = {
  kind: FavKind;
  entity_type?: string;
  entity_id?: string;
  url?: string;
  label: string;
  icon?: string;
};
export type FavoriteRow = FavoriteContext & { id: string; sort_order: number };

export function resolveFavoriteContext(
  pathname: string,
  currentLabel: string,
  pageLabel: string,
): FavoriteContext {
  const match = entityForPath(pathname);
  if (match) {
    return {
      kind: 'record',
      entity_type: match.entity_type,
      entity_id: match.entity_id,
      label: currentLabel || match.typeLabel,
      icon: match.icon,
    };
  }
  // A drilled page that publishes a crumb label but isn't a registry entity
  // (e.g. the report builder on /receivables/reports/:id) favorites as
  // ITSELF — the crumb label wins over the generic nav pageLabel, otherwise
  // every saved report starred as an identical "Reports" tile. List pages
  // publish no crumb label (records-only rule), so they keep pageLabel.
  return { kind: 'route', url: pathname, label: currentLabel || pageLabel || pathname, icon: 'page' };
}

export function favoriteKey(x: {
  kind: FavKind;
  entity_type?: string;
  entity_id?: string;
  url?: string;
}): string {
  return x.kind === 'record'
    ? `record:${x.entity_type}:${x.entity_id}`
    : `route:${x.url}`;
}

export function favoriteHref(f: {
  kind: FavKind;
  entity_type?: string;
  entity_id?: string;
  url?: string;
}): string {
  if (f.kind === 'record') {
    const r = routeForEntity(f.entity_type || '');
    return r ? `${r}/${f.entity_id}` : '/';
  }
  return f.url || '/';
}

export { entityForPath, routeForEntity };
